import React from 'react';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_LOW_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_THRESHOLD_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_THRESHOLD_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_MAX_COUNT_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_EMPTY_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_MAX_COUNT_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_EMPTY_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_DISCLAIMER_LABEL_DEFAULT } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { WorkflowSimplifiedExplanationConfig } from 'libs/end-to-end/src/types/databases/workflows/workflow-explanation-format';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { NumberInput } from 'apps/sigma2-ui/src/components/ui/NumberInput';

export interface ConfigureSimplifiedExplanationConfigProps {
  simplifiedExplanationConfig: WorkflowSimplifiedExplanationConfig;
  onUpdateSimplifiedExplanationConfig: (
    config: WorkflowSimplifiedExplanationConfig,
  ) => void;
}

export const ConfigureSimplifiedExplanationConfig: React.FC<
  ConfigureSimplifiedExplanationConfigProps
> = ({ simplifiedExplanationConfig, onUpdateSimplifiedExplanationConfig }) => {
  return (
    <Spacing size={'md'} direction={'vertical'}>
      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Low Match Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.lowLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              lowLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_LOW_LABEL_DEFAULT}
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Mixed Match Threshold
        </span>
        <NumberInput
          value={simplifiedExplanationConfig.mixedThreshold}
          onUpdate={(newValue) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              mixedThreshold: newValue,
            });
          }}
          placeholder={WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_THRESHOLD_DEFAULT.toString(
            10,
          )}
          showErrorHint={false}
          noMarginLeft={true}
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Mixed Match Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.mixedLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              mixedLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Strong Match Threshold
        </span>
        <NumberInput
          value={simplifiedExplanationConfig.strongThreshold}
          onUpdate={(newValue) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              strongThreshold: newValue,
            });
          }}
          placeholder={WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_THRESHOLD_DEFAULT.toString(
            10,
          )}
          showErrorHint={false}
          noMarginLeft={true}
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Strong Match Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.strongLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              strongLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Flags Max Count
        </span>
        <NumberInput
          value={simplifiedExplanationConfig.flagsMaxCount}
          onUpdate={(newValue) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              flagsMaxCount: newValue,
            });
          }}
          placeholder={WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_MAX_COUNT_DEFAULT.toString(
            10,
          )}
          showErrorHint={false}
          noMarginLeft={true}
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Flags Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.flagsLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              flagsLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Flags Empty Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.flagsEmptyLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              flagsEmptyLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_EMPTY_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Flags Hide Quantities
        </span>
        <input
          type="checkbox"
          checked={simplifiedExplanationConfig.flagsHideQuantities ?? false}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              flagsHideQuantities: e.target.checked,
            });
          }}
          className="form-checkbox p-2 rounded"
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Top Qualities Max Count
        </span>
        <NumberInput
          value={simplifiedExplanationConfig.topQualitiesMaxCount}
          onUpdate={(newValue) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              topQualitiesMaxCount: newValue,
            });
          }}
          placeholder={WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_MAX_COUNT_DEFAULT.toString(
            10,
          )}
          showErrorHint={false}
          noMarginLeft={true}
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Top Qualities Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.topQualitiesLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              topQualitiesLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Top Qualities Empty Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.topQualitiesEmptyLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              topQualitiesEmptyLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_EMPTY_LABEL_DEFAULT
          }
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Top Qualities Hide Quantities
        </span>
        <input
          type="checkbox"
          checked={
            simplifiedExplanationConfig.topQualitiesHideQuantities ?? false
          }
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              topQualitiesHideQuantities: e.target.checked,
            });
          }}
          className="form-checkbox p-2 rounded"
        />
      </label>

      <label className="space-y-1 flex flex-col">
        <span className="font-medium text-sm">
          Simplified Explanations - Disclaimer Label
        </span>
        <input
          type="text"
          value={simplifiedExplanationConfig.disclaimerLabel}
          onChange={(e) => {
            onUpdateSimplifiedExplanationConfig({
              ...simplifiedExplanationConfig,
              disclaimerLabel: e.target.value,
            });
          }}
          className="form-input border rounded p-2"
          placeholder={
            WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_DISCLAIMER_LABEL_DEFAULT
          }
        />
      </label>
    </Spacing>
  );
};
